import AWS from 'aws-sdk';

AWS.config.update({
    region: 'us-west-2',
    accessKeyId: 'AKIA5O2R6TDKSS6B4K6I',
    secretAccessKey: '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'
});

export default AWS;